import Head from 'next/head';
import type React from 'react';
import {twMerge} from 'tailwind-merge';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  id?: string;
  innerRef?: any;
  className?: string;
  index?: boolean;
};

const Page = ({children, style, id, innerRef, className, index}: Props) => {
  return (
    <div style={style} id={id} ref={innerRef} className={twMerge('flex flex-col min-h-full grow', className)}>
      {index ? null : (
        <Head>
          <meta name="robots" content="noindex" key="robots" />
        </Head>
      )}

      {children}
    </div>
  );
};

export default Page;
